export interface DemographicQuestion {
  id: string;
  label: string;
}

export const DEMOGRAPHIC_QUESTIONS: DemographicQuestion[] = [
  { id: "role", label: "What is your role?" },
  { id: "title", label: "What is your title?" },
  { id: "function", label: "What is your job functional area/division?" },
  { id: "location", label: "What is your location?" },
  { id: "company", label: "What is your company name?" },
  { id: "tenure", label: "What is your tenure at your company?" },
];
